function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import { FaEdit, FaEye } from "react-icons/fa";
import { colorStatus, colorCondition } from "./helper/polizaRenewalHelper";
import "./polizaRenewal.scss";
import * as moment from "moment";
import { fullName } from "../../helperComponents";

var ListPolizaRenewal = function ListPolizaRenewal(props) {
  var polizaRenewals = props.polizaRenewals,
      onSelectedPolizaRenewal = props.onSelectedPolizaRenewal,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      onSort = props.onSort; // Hook para detectar el tamaño de la pantalla

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isSmallScreen = _React$useState2[0],
      setIsSmallScreen = _React$useState2[1];

  React.useEffect(function () {
    var checkScreenSize = function checkScreenSize() {
      setIsSmallScreen(window.innerWidth <= 800);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return function () {
      return window.removeEventListener('resize', checkScreenSize);
    };
  }, []); // Mapeo de columnas a campos de Elasticsearch

  var columnFieldMap = {
    "Propuesta": "poliza_id",
    "Nº Póliza": "poliza.code.keyword",
    "Estado": "status_name.keyword",
    "Condición": "condition",
    "Decision": "",
    "N poliza nueva": "poliza.new_poliza.code.keyword",
    "Compañía": "poliza.company.name.keyword",
    "Asegurado": "poliza.asegurado.full_name.keyword",
    "Materia": "poliza.materia_asegurada_formatted.keyword",
    "Inicio Vigencia": "poliza.start_date",
    "Fin Vigencia": "poliza.finish_date",
    "Ramo": "poliza.ramo.keyword",
    "Prima Neta": "poliza.commission.net_bonus",
    "Prima Renovación": "net_bonus",
    "Ejecutivo": "poliza.commission.agent.keyword",
    "PDF Cargado en Cia": "new_poliza_pdf_uploaded.keyword",
    "Canal": "renewal_channel_name.keyword",
    "Comentario": "renewal_comment.keyword",
    "Fecha despacho Póliza Nueva": "new_poliza_dispatched_at",
    "Agente": "poliza.commission.agent.keyword",
    "Acciones": "" // No ordenable

  };

  var getSortIcon = function getSortIcon(columnName) {
    return null;
  };

  var handleHeaderClick = function handleHeaderClick(columnName, event) {
    event.preventDefault();
    event.stopPropagation();
    var field = columnFieldMap[columnName];

    if (field && onSort) {
      onSort(field);
    }
  }; // Función helper para estilos de celdas que permiten múltiples líneas


  var getCellStyle = function getCellStyle(width) {
    var additionalStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread({
      width: isSmallScreen ? "auto" : width,
      padding: isSmallScreen ? "8px 4px" : "4px 8px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal"
    }, additionalStyles);
  }; // Función helper para estilos de encabezados


  var getHeaderStyle = function getHeaderStyle(width) {
    return {
      width: isSmallScreen ? "auto" : width,
      cursor: "pointer",
      userSelect: "none",
      whiteSpace: "normal",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      padding: isSmallScreen ? "8px 4px" : undefined
    };
  };

  var getHeaderTooltip = function getHeaderTooltip(columnName) {
    return columnName;
  }; // Estado para el tooltip de scroll


  var _React$useState3 = React.useState({
    show: false,
    text: "",
    x: 0,
    y: 0
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      scrollTooltip = _React$useState4[0],
      setScrollTooltip = _React$useState4[1]; // Ref para la tabla y el contenedor scrollable


  var tableRef = React.useRef(null);
  var scrollRef = React.useRef(null); // Nombres de las columnas para el tooltip

  var columnNames = ["Propuesta", "Nº Póliza", "Estado", "Condición", "Decision", "N poliza nueva", "Compañía", "Asegurado", "Materia", "Inicio Vigencia", "Fin Vigencia", "Ramo", "Prima Neta", "Prima Renovación", "Ejecutivo", "PDF Cargado en Cia", "Canal", "Comentario", "Fecha despacho Póliza Nueva", "Agente", "Acciones"]; // Función para manejar el scroll y mostrar tooltip

  var handleScroll = function handleScroll(event) {
    if (!isSmallScreen) return;
    if (!tableRef.current || !scrollRef.current) return;
    var ths = tableRef.current.querySelectorAll('thead th');
    if (!ths.length) return;
    var scrollLeft = scrollRef.current.scrollLeft;
    var clientWidth = scrollRef.current.clientWidth; // Encontrar la columna que está en el centro del viewport

    var viewportCenter = scrollLeft + clientWidth / 2;
    var closestColumn = 0;
    var minDistance = Infinity;
    ths.forEach(function (th, idx) {
      var thElement = th;
      var thLeft = thElement.offsetLeft;
      var thWidth = thElement.offsetWidth;
      var thCenter = thLeft + thWidth / 2;
      var distance = Math.abs(thCenter - viewportCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestColumn = idx;
      }
    }); // Posicionar el tooltip justo encima de la barra de scroll

    var scrollRect = scrollRef.current.getBoundingClientRect();
    var scrollbarY = scrollRect.bottom - 20; // 20px arriba de la barra
    // Calcular posición X basada en la columna más cercana al centro

    var thElement = ths[closestColumn];
    var thLeft = thElement.offsetLeft;
    var thWidth = thElement.offsetWidth;
    var thCenter = thLeft + thWidth / 2; // Ajustar la posición X para que esté centrada en la columna

    var adjustedX = scrollRect.left + (thCenter - scrollLeft); // Solo mostrar tooltip si hay scroll horizontal

    if (scrollLeft > 0 || scrollRef.current.scrollWidth > scrollRef.current.clientWidth) {
      setScrollTooltip({
        show: true,
        text: "Columna: ".concat(columnNames[closestColumn]),
        x: adjustedX,
        y: scrollbarY
      });
    }
  }; // Función para ocultar tooltip cuando se suelta el scroll


  var handleScrollEnd = function handleScrollEnd() {
    setScrollTooltip(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        show: false
      });
    });
  }; // Función para manejar cuando se suelta el mouse o el touch


  var handleMouseUp = function handleMouseUp() {
    handleScrollEnd();
  };

  var handleTouchEnd = function handleTouchEnd() {
    handleScrollEnd();
  }; // Función para manejar cuando se mueve el mouse sobre la barra de scroll


  var handleMouseMove = function handleMouseMove(event) {
    if (!isSmallScreen) return;
    if (!scrollRef.current) return;
    var rect = scrollRef.current.getBoundingClientRect();
    var mouseY = event.clientY; // Solo mostrar tooltip si el mouse está cerca de la barra de scroll

    if (mouseY >= rect.bottom - 30) {
      handleScroll(event);
    } else {
      handleScrollEnd();
    }
  };
  /* poliza.status PUEDEN SER => "BORRADOR" , "VIGENTE", "NO VIGENTE"
  poliza.sub_status PUEDEN SER => "NUEVA", "POR RENOVAR" ..... */
  // Función helper para truncar texto a 80 caracteres


  var truncateText = function truncateText(text) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
    if (!text) return "-";
    var textStr = String(text);
    if (textStr.length <= maxLength) return textStr;
    return textStr.substring(0, maxLength) + "...";
  };

  var listPolizaRenewals = function listPolizaRenewals() {
    return polizaRenewals.map(function (polizaRenewal) {
      var _polizaRenewal$poliza, _polizaRenewal$poliza2, _polizaRenewal$poliza3, _polizaRenewal$poliza4, _polizaRenewal$poliza5, _polizaRenewal$poliza6, _polizaRenewal$poliza7, _polizaRenewal$poliza8, _polizaRenewal$poliza9, _polizaRenewal$poliza10, _polizaRenewal$poliza11, _polizaRenewal$poliza12, _polizaRenewal$poliza13, _polizaRenewal$poliza14, _polizaRenewal$poliza15, _polizaRenewal$poliza16, _polizaRenewal$poliza17, _polizaRenewal$poliza18, _polizaRenewal$poliza19, _polizaRenewal$poliza20, _polizaRenewal$poliza21, _polizaRenewal$poliza22, _polizaRenewal$poliza23, _polizaRenewal$poliza24, _polizaRenewal$poliza25, _polizaRenewal$poliza26, _polizaRenewal$poliza27, _polizaRenewal$poliza28, _polizaRenewal$poliza29, _polizaRenewal$poliza30, _polizaRenewal$poliza31, _polizaRenewal$poliza32, _polizaRenewal$poliza33, _polizaRenewal$poliza34;

      var exec = (_polizaRenewal$poliza = polizaRenewal.poliza) === null || _polizaRenewal$poliza === void 0 ? void 0 : (_polizaRenewal$poliza2 = _polizaRenewal$poliza.commission) === null || _polizaRenewal$poliza2 === void 0 ? void 0 : _polizaRenewal$poliza2.insurance_broker_executive;
      var executiveDisplay = exec ? [exec.full_name, exec.rut].filter(Boolean).join(" ").trim() || null : (_polizaRenewal$poliza3 = (_polizaRenewal$poliza4 = polizaRenewal.poliza) === null || _polizaRenewal$poliza4 === void 0 ? void 0 : (_polizaRenewal$poliza5 = _polizaRenewal$poliza4.commission) === null || _polizaRenewal$poliza5 === void 0 ? void 0 : _polizaRenewal$poliza5.agent) !== null && _polizaRenewal$poliza3 !== void 0 ? _polizaRenewal$poliza3 : null;
      return /*#__PURE__*/React.createElement("tr", {
        key: polizaRenewal.id
      }, /*#__PURE__*/React.createElement("th", {
        scope: "row",
        "data-title": "Propuesta: ".concat(polizaRenewal.poliza_id),
        title: "Propuesta: ".concat(polizaRenewal.poliza_id),
        style: getCellStyle("6%", {
          position: "relative"
        })
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id),
        title: "Propuesta: ".concat(polizaRenewal.poliza_id),
        style: {
          pointerEvents: "auto"
        }
      }, polizaRenewal.poliza_id)), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("9%", {
          textAlign: "center",
          position: "relative"
        }),
        title: polizaRenewal.poliza.code ? "N\xBA P\xF3liza: ".concat(polizaRenewal.poliza.code) : "Nº Póliza: -"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#polizaRenewalModal",
        "data-toggle": "modal",
        "data-target": "#polizaRenewalModal",
        onClick: function onClick() {
          onSelectedPolizaRenewal && onSelectedPolizaRenewal(polizaRenewal);
        },
        style: {
          fontSize: "13px",
          fontWeight: "600",
          color: "#2596be",
          textDecoration: "none",
          letterSpacing: "0.5px"
        },
        title: polizaRenewal.poliza.code ? "N\xBA P\xF3liza: ".concat(polizaRenewal.poliza.code) : "Nº Póliza: -",
        "data-title": polizaRenewal.poliza.code ? "N\xBA P\xF3liza: ".concat(polizaRenewal.poliza.code) : "Nº Póliza: -"
      }, truncateText(polizaRenewal.poliza.code || "Ver", 80))), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.status_name ? "Estado: ".concat(polizaRenewal.status_name) : "Estado: -",
        title: polizaRenewal.status_name ? "Estado: ".concat(polizaRenewal.status_name) : "Estado: -",
        style: getCellStyle("6%")
      }, colorStatus(polizaRenewal.status_name), " ", truncateText(polizaRenewal.status_name)), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.condition ? "Condici\xF3n: ".concat(function () {
          switch (polizaRenewal.condition) {
            case "same_conditions":
              return "Iguales condiciones";

            case "change_conditions":
              return "Cambio condiciones";

            case "without_conditions":
              return "Sin condiciones";

            case "extension":
              return "Prorroga";

            case "client_rejects_renewal":
              return "No renueva cliente";

            case "company_rejects_renewal":
              return "No renueva Compañía";

            default:
              return polizaRenewal.condition;
          }
        }()) : "Condición: -",
        title: polizaRenewal.condition ? "Condici\xF3n: ".concat(function () {
          switch (polizaRenewal.condition) {
            case "same_conditions":
              return "Iguales condiciones";

            case "change_conditions":
              return "Cambio condiciones";

            case "without_conditions":
              return "Sin condiciones";

            case "extension":
              return "Prorroga";

            case "client_rejects_renewal":
              return "No renueva cliente";

            case "company_rejects_renewal":
              return "No renueva Compañía";

            default:
              return polizaRenewal.condition;
          }
        }()) : "Condición: -",
        style: getCellStyle("6%")
      }, colorCondition(polizaRenewal.condition), " ", truncateText(polizaRenewal.condition ? function () {
        switch (polizaRenewal.condition) {
          case "same_conditions":
            return "Iguales condiciones";

          case "change_conditions":
            return "Cambio condiciones";

          case "without_conditions":
            return "Sin condiciones";

          case "extension":
            return "Prorroga";

          case "client_rejects_renewal":
            return "No renueva cliente";

          case "company_rejects_renewal":
            return "No renueva Compañía";

          default:
            return polizaRenewal.condition;
        }
      }() : "-")), /*#__PURE__*/React.createElement("td", {
        "data-title": "Decision: -",
        title: "Decision: -",
        style: getCellStyle("6%")
      }, "-"), /*#__PURE__*/React.createElement("td", {
        "data-title": (_polizaRenewal$poliza6 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza6 !== void 0 && (_polizaRenewal$poliza7 = _polizaRenewal$poliza6.new_poliza) !== null && _polizaRenewal$poliza7 !== void 0 && _polizaRenewal$poliza7.code ? "N poliza nueva: ".concat(polizaRenewal.poliza.new_poliza.code) : "N poliza nueva: -",
        title: (_polizaRenewal$poliza8 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza8 !== void 0 && (_polizaRenewal$poliza9 = _polizaRenewal$poliza8.new_poliza) !== null && _polizaRenewal$poliza9 !== void 0 && _polizaRenewal$poliza9.code ? "N poliza nueva: ".concat(polizaRenewal.poliza.new_poliza.code) : "N poliza nueva: -",
        style: getCellStyle("6%")
      }, truncateText((_polizaRenewal$poliza10 = polizaRenewal.poliza) === null || _polizaRenewal$poliza10 === void 0 ? void 0 : (_polizaRenewal$poliza11 = _polizaRenewal$poliza10.new_poliza) === null || _polizaRenewal$poliza11 === void 0 ? void 0 : _polizaRenewal$poliza11.code)), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.poliza.company ? "Compa\xF1\xEDa: ".concat(polizaRenewal.poliza.company.name) : "Compañía: -",
        title: polizaRenewal.poliza.company ? "Compa\xF1\xEDa: ".concat(polizaRenewal.poliza.company.name) : "Compañía: -",
        style: getCellStyle("8%")
      }, truncateText((_polizaRenewal$poliza12 = polizaRenewal.poliza.company) === null || _polizaRenewal$poliza12 === void 0 ? void 0 : _polizaRenewal$poliza12.name)), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.poliza.asegurado ? "Asegurado: ".concat(fullName(polizaRenewal.poliza.asegurado), " ").concat(formatRut(polizaRenewal.poliza.asegurado.rut || "")) : "Asegurado: -",
        title: polizaRenewal.poliza.asegurado ? "Asegurado: ".concat(fullName(polizaRenewal.poliza.asegurado), " ").concat(formatRut(polizaRenewal.poliza.asegurado.rut || "")) : "Asegurado: -",
        style: getCellStyle("9%")
      }, truncateText(polizaRenewal.poliza.asegurado ? "".concat(fullName(polizaRenewal.poliza.asegurado), " ").concat(formatRut(polizaRenewal.poliza.asegurado.rut || "")) : "-")), /*#__PURE__*/React.createElement("td", {
        "data-title": (_polizaRenewal$poliza13 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza13 !== void 0 && _polizaRenewal$poliza13.item_asegurados ? "Materia: ".concat(polizaRenewal.poliza.materia_asegurada_formatted || "-") : "Materia: -",
        title: (_polizaRenewal$poliza14 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza14 !== void 0 && _polizaRenewal$poliza14.item_asegurados ? "Materia: ".concat(polizaRenewal.poliza.materia_asegurada_formatted || "-") : "Materia: -",
        style: getCellStyle("10%")
      }, truncateText((_polizaRenewal$poliza15 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza15 !== void 0 && _polizaRenewal$poliza15.item_asegurados ? polizaRenewal.poliza.materia_asegurada_formatted : null)), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.poliza.start_date ? "Inicio Vigencia: ".concat(moment(polizaRenewal.poliza.start_date).format("DD-MM-YYYY")) : "Inicio Vigencia: -",
        title: polizaRenewal.poliza.start_date ? "Inicio Vigencia: ".concat(moment(polizaRenewal.poliza.start_date).format("DD-MM-YYYY")) : "Inicio Vigencia: -",
        style: getCellStyle("6%")
      }, polizaRenewal.poliza.start_date ? moment(polizaRenewal.poliza.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.poliza.finish_date ? "Fin Vigencia: ".concat(moment(polizaRenewal.poliza.finish_date).format("DD-MM-YYYY")) : "Fin Vigencia: -",
        title: polizaRenewal.poliza.finish_date ? "Fin Vigencia: ".concat(moment(polizaRenewal.poliza.finish_date).format("DD-MM-YYYY")) : "Fin Vigencia: -",
        style: getCellStyle("7%")
      }, /*#__PURE__*/React.createElement("b", null, polizaRenewal.poliza.finish_date ? moment(polizaRenewal.poliza.finish_date).format("DD-MM-YYYY") : "-")), /*#__PURE__*/React.createElement("td", {
        "data-title": (_polizaRenewal$poliza16 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza16 !== void 0 && _polizaRenewal$poliza16.ramo ? "Ramo: ".concat(polizaRenewal.poliza.ramo) : "Ramo: -",
        title: (_polizaRenewal$poliza17 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza17 !== void 0 && _polizaRenewal$poliza17.ramo ? "Ramo: ".concat(polizaRenewal.poliza.ramo) : "Ramo: -",
        style: getCellStyle("8%")
      }, truncateText((_polizaRenewal$poliza18 = polizaRenewal.poliza) === null || _polizaRenewal$poliza18 === void 0 ? void 0 : _polizaRenewal$poliza18.ramo)), /*#__PURE__*/React.createElement("td", {
        "data-title": (_polizaRenewal$poliza19 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza19 !== void 0 && (_polizaRenewal$poliza20 = _polizaRenewal$poliza19.commission) !== null && _polizaRenewal$poliza20 !== void 0 && _polizaRenewal$poliza20.net_bonus ? "Prima Neta: ".concat(((_polizaRenewal$poliza21 = polizaRenewal.poliza) === null || _polizaRenewal$poliza21 === void 0 ? void 0 : _polizaRenewal$poliza21.currency) || "", " ").concat((_polizaRenewal$poliza22 = polizaRenewal.poliza) === null || _polizaRenewal$poliza22 === void 0 ? void 0 : (_polizaRenewal$poliza23 = _polizaRenewal$poliza22.commission) === null || _polizaRenewal$poliza23 === void 0 ? void 0 : _polizaRenewal$poliza23.net_bonus).trim() : "Prima Neta: -",
        title: (_polizaRenewal$poliza24 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza24 !== void 0 && (_polizaRenewal$poliza25 = _polizaRenewal$poliza24.commission) !== null && _polizaRenewal$poliza25 !== void 0 && _polizaRenewal$poliza25.net_bonus ? "Prima Neta: ".concat(((_polizaRenewal$poliza26 = polizaRenewal.poliza) === null || _polizaRenewal$poliza26 === void 0 ? void 0 : _polizaRenewal$poliza26.currency) || "", " ").concat((_polizaRenewal$poliza27 = polizaRenewal.poliza) === null || _polizaRenewal$poliza27 === void 0 ? void 0 : (_polizaRenewal$poliza28 = _polizaRenewal$poliza27.commission) === null || _polizaRenewal$poliza28 === void 0 ? void 0 : _polizaRenewal$poliza28.net_bonus).trim() : "Prima Neta: -",
        style: getCellStyle("5%")
      }, truncateText("".concat(((_polizaRenewal$poliza29 = polizaRenewal.poliza) === null || _polizaRenewal$poliza29 === void 0 ? void 0 : _polizaRenewal$poliza29.currency) || "", " ").concat(((_polizaRenewal$poliza30 = polizaRenewal.poliza) === null || _polizaRenewal$poliza30 === void 0 ? void 0 : (_polizaRenewal$poliza31 = _polizaRenewal$poliza30.commission) === null || _polizaRenewal$poliza31 === void 0 ? void 0 : _polizaRenewal$poliza31.net_bonus) || "-").trim())), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.net_bonus ? "Prima Renovaci\xF3n: ".concat(((_polizaRenewal$poliza32 = polizaRenewal.poliza) === null || _polizaRenewal$poliza32 === void 0 ? void 0 : _polizaRenewal$poliza32.currency) || "", " ").concat(polizaRenewal.net_bonus).trim() : "Prima Renovación: -",
        title: polizaRenewal.net_bonus ? "Prima Renovaci\xF3n: ".concat(((_polizaRenewal$poliza33 = polizaRenewal.poliza) === null || _polizaRenewal$poliza33 === void 0 ? void 0 : _polizaRenewal$poliza33.currency) || "", " ").concat(polizaRenewal.net_bonus).trim() : "Prima Renovación: -",
        style: getCellStyle("5%")
      }, truncateText("".concat(((_polizaRenewal$poliza34 = polizaRenewal.poliza) === null || _polizaRenewal$poliza34 === void 0 ? void 0 : _polizaRenewal$poliza34.currency) || "", " ").concat(polizaRenewal.net_bonus || "-").trim())), /*#__PURE__*/React.createElement("td", {
        "data-title": executiveDisplay ? "Agente: ".concat(executiveDisplay) : "Agente: -",
        title: executiveDisplay ? "Agente: ".concat(executiveDisplay) : "Agente: -",
        style: getCellStyle("7%")
      }, truncateText(executiveDisplay)), /*#__PURE__*/React.createElement("td", {
        "data-title": "PDF Cargado en Cia: ".concat(polizaRenewal.new_poliza_pdf_uploaded || "-"),
        title: "PDF Cargado en Cia: ".concat(polizaRenewal.new_poliza_pdf_uploaded || "-"),
        style: getCellStyle("5%")
      }, polizaRenewal.new_poliza_pdf_uploaded || "-"), /*#__PURE__*/React.createElement("td", {
        "data-title": "Canal: ".concat(polizaRenewal.renewal_channel_name || "-"),
        title: "Canal: ".concat(polizaRenewal.renewal_channel_name || "-"),
        style: getCellStyle("6%")
      }, truncateText(polizaRenewal.renewal_channel_name)), /*#__PURE__*/React.createElement("td", {
        "data-title": "Comentario: ".concat(polizaRenewal.renewal_comment || "-"),
        title: "Comentario: ".concat(polizaRenewal.renewal_comment || "-"),
        style: getCellStyle("7%")
      }, truncateText(polizaRenewal.renewal_comment, 100)), /*#__PURE__*/React.createElement("td", {
        "data-title": polizaRenewal.new_poliza_dispatched_at ? "Fecha despacho P\xF3liza Nueva: ".concat(moment(polizaRenewal.new_poliza_dispatched_at).format("DD-MM-YYYY")) : "Fecha despacho Póliza Nueva: -",
        title: polizaRenewal.new_poliza_dispatched_at ? "Fecha despacho P\xF3liza Nueva: ".concat(moment(polizaRenewal.new_poliza_dispatched_at).format("DD-MM-YYYY")) : "Fecha despacho Póliza Nueva: -",
        style: getCellStyle("7%")
      }, polizaRenewal.new_poliza_dispatched_at ? moment(polizaRenewal.new_poliza_dispatched_at).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("4%", {
          textAlign: "center"
        })
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id),
        className: "btn btn-info btn-xs",
        title: "Ver p\xF3liza",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        },
        target: "_blank"
      }, /*#__PURE__*/React.createElement(FaEye, null)), /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id, "/renew"),
        className: "btn btn-primary btn-xs",
        title: "Editar renovaci\xF3n",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaEdit, null)))));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !polizaRenewals || polizaRenewals.length <= 0 ? /*#__PURE__*/React.createElement("h3", null, "No se han encontrado p\xF3lizas a renovar.") : /*#__PURE__*/React.createElement("div", {
    className: "table-responsive",
    style: {
      overflowX: "auto",
      overflowY: "visible",
      width: "100%",
      position: "relative",
      display: "block"
    },
    ref: scrollRef
  }, /*#__PURE__*/React.createElement("table", {
    ref: tableRef,
    className: "table table-striped table-sm table-bordered cntListPoliza",
    "data-toggle": "table",
    style: {
      width: "100%",
      minWidth: isSmallScreen ? "100%" : "1400px",
      tableLayout: isSmallScreen ? "auto" : "fixed"
    }
  }, /*#__PURE__*/React.createElement("thead", {
    className: "tableHeader"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Propuesta", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("Propuesta")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Prop.", getSortIcon("Propuesta"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Nº Póliza", e);
    },
    style: getHeaderStyle("9%"),
    "data-title": getHeaderTooltip("Nº Póliza")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "N\xBA P\xF3liza", getSortIcon("Nº Póliza"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Estado", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("Estado")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Estado", getSortIcon("Estado"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Condición", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("Condición")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Condici\xF3n", getSortIcon("Condición"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    style: getHeaderStyle("6%"),
    "data-title": "Decision"
  }, "Decision"), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("N poliza nueva", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("N poliza nueva")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "N poliza nueva", getSortIcon("N poliza nueva"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Compañía", e);
    },
    style: getHeaderStyle("8%"),
    "data-title": getHeaderTooltip("Compañía")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Compa\xF1\xEDa", getSortIcon("Compañía"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Asegurado", e);
    },
    style: getHeaderStyle("9%"),
    "data-title": getHeaderTooltip("Asegurado")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Asegurado", getSortIcon("Asegurado"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Materia", e);
    },
    style: getHeaderStyle("10%"),
    "data-title": getHeaderTooltip("Materia")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Materia", getSortIcon("Materia"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Inicio Vigencia", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("Inicio Vigencia")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Inicio Vigencia", getSortIcon("Inicio Vigencia"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Fin Vigencia", e);
    },
    style: getHeaderStyle("7%"),
    "data-title": getHeaderTooltip("Fin Vigencia")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Fin Vigencia", getSortIcon("Fin Vigencia"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Ramo", e);
    },
    style: getHeaderStyle("8%"),
    "data-title": getHeaderTooltip("Ramo")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Ramo", getSortIcon("Ramo"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Prima Neta", e);
    },
    style: getHeaderStyle("5%"),
    "data-title": getHeaderTooltip("Prima Neta")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Prima Neta", getSortIcon("Prima Neta"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Prima Renovación", e);
    },
    style: getHeaderStyle("5%"),
    "data-title": getHeaderTooltip("Prima Renovación")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Prima Renov.", getSortIcon("Prima Renovación"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Agente", e);
    },
    style: getHeaderStyle("7%"),
    "data-title": getHeaderTooltip("Ejecutivo")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Agente", getSortIcon("Agente"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("PDF Cargado en Cia", e);
    },
    style: getHeaderStyle("5%"),
    "data-title": getHeaderTooltip("PDF Cargado en Cia")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "PDF Cargado en Cia", getSortIcon("PDF Cargado en Cia"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Canal", e);
    },
    style: getHeaderStyle("6%"),
    "data-title": getHeaderTooltip("Canal")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Canal", getSortIcon("Canal"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Comentario", e);
    },
    style: getHeaderStyle("7%"),
    "data-title": getHeaderTooltip("Comentario")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Comentario", getSortIcon("Comentario"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    onClick: function onClick(e) {
      return handleHeaderClick("Fecha despacho Póliza Nueva", e);
    },
    style: getHeaderStyle("7%"),
    "data-title": getHeaderTooltip("Fecha despacho Póliza Nueva")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: isSmallScreen ? "wrap" : "nowrap"
    }
  }, "Fecha despacho P\xF3liza Nueva", getSortIcon("Fecha despacho Póliza Nueva"))), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    style: getHeaderStyle("4%"),
    "data-title": "Acciones"
  }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
    className: "tableBody"
  }, listPolizaRenewals()))));
};

export default ListPolizaRenewal;